<header class="no-margins-hug hug-header home-header margin-vertical-header " [ngClass]="{'w-100 mh24': isAcmic}">
  <div class="billing-header-acmic" *ngIf="isAcmic">
    <img 
      src="{{policy?.displayType?.icon}}"
      width="40" height="40" 
      alt="{{policy?.policyType?.toLowerCase()}} icon"
      class="header-icon-ml"
    />
  </div>
    <div class="type-title deliquency-notice">
        <h1 class="title" [ngClass]="{'term-display comm-acmic-header':isAcmic}">
            <ng-container *ngIf="!isAcmic; else acmicPolicyType">
                <span class="{{ policy?.policyType | lowercase }} icon-flex-container policy-type-wrap margin-bottom">
                  <img 
                    src="{{policy?.displayType?.icon}}"
                    width="40" height="40" 
                    class="margin-right mr8"
                    alt="{{policy?.policyType?.toLowerCase()}} icon"
                  />
                    {{ policy?.displayType?.label }} - {{ policy?.policynumber.policyNumber }} 
                </span>
            </ng-container>
            <ng-template #acmicPolicyType>
              <span class="margin-bottom mb8">{{ policy?.displayType?.label }} - {{ policy?.policynumber.policyNumber }}</span>
            </ng-template>            
            <span class="policy-date-wrap" [ngClass]="{'col-2d373d': (policy?.policyStatus === 'ACTIVE' || policy?.policyStatus === 'FUTURE'),
            'red-color': !(policy?.policyStatus === 'ACTIVE' || policy?.policyStatus === 'FUTURE') }">
              <small class="display-inline policy-date-text" [ngClass]="{'reponsive-mt-8': isAcmic}">
                <strong [ngClass]="{'fw-500 col-363636':isAcmic}"> 
                  {{ policy?.effDate | customDateFormat }} {{ '-' | translate }}
                  {{ policy?.expDate | customDateFormat }}
                </strong>
              </small>
            </span>
          </h1>
    </div>

    <ng-container *ngIf="policy?.isDelinquency">
     <div class="margin-top mt16 del-margin bn-error-notice-sec" [ngClass]="{'acmic-notice-container':isAcmic}">
        <app-bn-error-notice 
          [amount]='policy?.exitDelinquencyAmount?.theAmount' 
          [date]='policy?.policyCancellationEffectiveDate'
          [policyCancellationReason]='policy?.policyCancellationReason'
          [policy]='policy'>
        </app-bn-error-notice>
      </div>
    </ng-container>

  </header>